import React from "react";

const StaffIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 17.5044 17.8853"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.354,13.6252v-4.46c0,-0.272 -0.2227,-0.495 -0.4951,-0.495h-4.2998v-1.15h4.2998c0.9076,0 1.6455,0.738 1.6455,1.645v4.46c-0.0001,0.908 -0.738,1.645 -1.6455,1.645h-3.9394v-1.15h3.9394c0.2723,0 0.495,-0.222 0.4951,-0.495z"
        fill="currentColor"
      />
      <path
        d="M3.7554,10.9552c0.302,-0.04 0.6412,-0.016 0.9639,0.115l0.1875,0.069c0.44,0.151 0.8956,0.231 1.3623,0.231c0.5427,0 1.0517,-0.105 1.5498,-0.3l0.0069,-0.003l0.0068,-0.002c0.2354,-0.086 0.4783,-0.121 0.706,-0.122l0.2227,0.009l0.0215,0.002c1.2694,0.164 2.7421,0.772 3.4404,2.336l0.1289,0.326l0.001,0.002c0.1992,0.579 0.2008,1.249 0.1709,1.926c-0.0315,0.712 -0.0996,1.456 -0.0996,2.341h-1.1504c0,-0.915 0.0721,-1.746 0.1006,-2.391c0.03,-0.68 0.0113,-1.15 -0.1094,-1.501v-0.001c-0.4282,-1.225 -1.4934,-1.747 -2.6123,-1.895c-0.1514,-0.013 -0.303,0.003 -0.4277,0.049l-0.001,-0.001c-0.6174,0.241 -1.2633,0.375 -1.9551,0.375c-0.6866,0 -1.3483,-0.135 -1.9707,-0.38l-0.0068,-0.003c-0.1137,-0.046 -0.2501,-0.06 -0.3848,-0.042h-0.0039c-1.1268,0.145 -2.2096,0.677 -2.6299,1.898c-0.1207,0.351 -0.1394,0.821 -0.1094,1.501c0.0286,0.645 0.1006,1.476 0.1006,2.391h-1.1504c0,-0.885 -0.0681,-1.629 -0.0996,-2.341c-0.0299,-0.677 -0.0283,-1.347 0.1709,-1.926c0.6198,-1.8 2.2172,-2.489 3.5703,-2.664z"
        fill="currentColor"
      />
      <path
        d="M6.2694,0.0002c2.7508,0 4.9649,2.291 4.9649,5.075v0.575h-0.043c-0.2764,2.519 -2.3289,4.83 -4.9326,4.83c-2.8003,0 -4.9649,-2.664 -4.9649,-5.405c0,-2.797 2.2272,-5.075 4.9756,-5.075zM2.4442,5.0752c0,2.239 1.7751,4.255 3.8145,4.255c2.0389,0 3.8154,-2.025 3.8154,-4.255v-0.27c-0.1355,-2.048 -1.8028,-3.655 -3.8047,-3.655c-2.0915,0 -3.8252,1.742 -3.8252,3.925z"
        fill="currentColor"
      />
      <path
        d="M8.5691,17.1152c0.8892,0 1.61,-0.721 1.61,-1.61c0,-0.889 -0.7208,-1.61 -1.61,-1.61c-0.8892,0 -1.61,0.721 -1.61,1.61c0,0.889 0.7208,1.61 1.61,1.61z"
        fill="#1A8B5A"
      />
      <path
        d="M15.099,11.3052v0.85h-2.14v-2.93h0.86v2.08z"
        fill="#1A8B5A"
      />
    </svg>
  );
};

export default StaffIcon;
